import React, {
  Component
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Space, Table, Form, Select, Input, Typography, Modal } from 'antd';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import Spinner from "../../UIComponents/Spinner/Spinner";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { CreateQuotation,ClearMessage } from './actions/QuotationServices';
import Cookie from 'js-cookie';
import { connect } from 'react-redux';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { GetTechnicianPMPList } from '../PMP/actions/pmpService';
import LZString from 'lz-string';
const { confirm } = Modal;
const { Text } = Typography;
const { Option } = Select;

class AddQuotation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      title: 'Create New Quotation',
      DeleteConfirmModal: false,
      isSubmit:false,
      quatationTotalsum:0,
      vendorComments:"",
      QuotationTableColumns: [
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record,index) => {
            return (
              <Space size="middle">
                <div className="table-icons">
                  <i className="fa fa-trash-o text-danger" aria-hidden="true" onClick={()=>this._doshowConfirmModal(index)}></i>
                </div>
              </Space>
            )
          }

        },
        {
          title: "Item Name",
          dataIndex: "item_name",
          key: "item_name"
        },
        {
          title: "Brand/Make",
          dataIndex: "item_brand",
          key: "item_brand"
        },
        {
          title: "item_capacity ",
          dataIndex: "item_capacity",
          key: "item_capacity "
        },
        {
          title: "item_quantity ",
          dataIndex: "item_quantity",
          key: "item_quantity "
        },
        {
          title: "Cost",
          dataIndex: "item_price",
          key: "Cost"
        },
        {
          title: "GST",
          dataIndex: "item_gst",
          key: "GST"
        },
        {
          title: "Total",
          dataIndex: "item_sub_total",
          key: "Total"
        }
      ],
      QuotationTableData: [
      ],
      loading: false,
      quotationSubmit: {
        item_name: '',
        item_brand: '',
        item_capacity: '',
        item_quantity: '',
        item_price: '',
        item_gst: '',
        item_sub_total:'',
        record_deleted:0,
      },
      technicianId:'',
      technicianNumber:null,
      isTechnicianSelected:false,
      filewithbase64:'',
      filename:'',
      pdfFile:null,
      pdfError:''
    };
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    this.userID = user['userId'];
    this.cost = 0;
    this.gst = 0;
    this.qty=0;
  };

  // Calculating Total cost //
  calculateTotal = () => {
    let price = Number(this.state.item_quantity ) * Number(this.state.item_price );
    let total = (price * (Number(this.state.item_gst ) / 100)) + price;
    this.setState({
      item_sub_total: total
    });
    // console.log(this.state.item_quantity , this.state.cost, this.state.GST);
  }
  handleChange = (e, fieldInput) => {
    // console.log(this.state.item_quantity );
    if (fieldInput === "item_quantity ") {
      this.setState({
        item_quantity : e.target.value
      }, this.calculateTotal)
    }
    else if (fieldInput === "item_price ") {
      this.setState({
        item_price : e.target.value
      }, this.calculateTotal)
    }
    else if (fieldInput === "gst") {
      this.setState({
        item_gst : e.target.value
      }, this.calculateTotal)
    }
    else if (fieldInput === "item_name") {
      this.setState({
        item_name: e.target.value
      })
    }
    else if (fieldInput === "item_brand ") {
      this.setState({
        item_brand : e.target.value
      })
    }
    else if (fieldInput === "item_capacity ") {
      this.setState({
        item_capacity : e.target.value
      })
    }
  };

  componentDidMount() {
    
    // if(typeof(this.props.SelectedData)=='undefined'){
    //     this.props.navigate({
    //       pathname:this.props.location.state.fromAddress, 
    //       state:{selectedStoreId:this.props.location.state.selectedId}
    //     });
    // }
    this.props.GetTechnicianPMPList()
    this._doGetAddQuotationList();
  };

  _doGetAddQuotationList() {
    this.setState({
      loading: true,
      modalOpen: false,
      message: "",
    });

    var _this = this;
    // Remove while API integration
    setTimeout(function () {
      _this.setState({
        loading: false
      });
    }, 300);

  };

  _doToggleDeleteConfirmModal = (state) => {
    this.setState({
      DeleteConfirmModal: true
    })
  }

  _doshowConfirmModal = (i) => {
    const deleteTableData = (index) => {
      let tableData = [...this.state.QuotationTableData];
      tableData.splice(index, 1);
      this.setState({
        QuotationTableData: tableData
      })
    }

    confirm({
      title: 'Do you Want to delete these items?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        console.log(i, 'confirmModalyy');
        deleteTableData(i)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  _doNavToQuotationVendor = () => {
  //   this.props.navigate({
  //     pathname:this.props.location.state.fromAddress, 
  //     state:{selectedStoreId:this.props.location.state.selectedId}
  // });
  this.props.CloseAddQuotation();
  }
  handleFile = (e)=>{
      const fileType = ['application/pdf'];
      // this.setState({filename:e.target.value})
      let selectedFile = e.target.files[0];
      if(typeof(selectedFile) == "undefined"){
        this.setState({filename:'',filewithbase64:''})
        console.log(this.state.filename,'filename')
        return
      }
      if(selectedFile.type  =="application/pdf" || 
      selectedFile.type =="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || 
      selectedFile.type =="application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
        this.setState({filename:selectedFile.name})
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = () => {
          let encoded = this.setState({filewithbase64:reader.result.toString().replace(/^data:(.*,)?/, '')})
        }
        reader.onerror = error => console.log(error)
    }
    else{
      console.log(selectedFile.type,'elseBlock')
      this.clearFileUpload()
    }

  }
  handleInput = (e, name) => {
    if (name == 'item_price') {
      // var cost = 0;
      this.cost = Number(e.target.value);
      //console.log('I am in item_price ', this.cost);
      }
    if (name == 'item_gst') {
      // var gst = 0;
      this.gst = Number(e.target.value);
      //console.log('I am in GST', this.gst);
      }
      if(name=='item_quantity'){
      this.qty= Number(e.target.value);
      }

    this.setState({
      quotationSubmit: {
        ...this.state.quotationSubmit,
        
        [name]: e.target.value.replace(/[^\w\s]/gi, ""),
        item_sub_total: parseFloat(((Number(this.cost) * (Number(this.gst) / 100)) + Number(this.cost))*this.qty).toFixed(2)
      }
    },)
  }
  clearFileUpload = () =>{
    console.log(document.getElementsByClassName('upload-file'),'inside file upload')
    document.getElementsByClassName('upload-file')[0].value = null;
    this.setState({pdfFile:null,pdfError:'please upload pdf file'})
    // this.setState({filewithbase64:'',filename:''})
  }
  _doAddtoQuotationList = () => {
    // console.log("eveent")
    this.setState({isSubmit:true})
    let formSubmit = true
    console.log(this.state.quotationSubmit.item_name=='' , formSubmit )
    if(this.state.quotationSubmit.item_name=='' && formSubmit )return
    else if(this.state.quotationSubmit.item_brand ==''&& formSubmit )return
    else if(this.state.quotationSubmit.item_capacity =='' && formSubmit )return
    else if(this.state.quotationSubmit.item_quantity =='' && this.state.quotationSubmit.item_quantity ==0 && formSubmit )return
    else if(this.state.quotationSubmit.item_price =='' && this.state.quotationSubmit.item_price ==0 && formSubmit )return
    else if(this.state.quotationSubmit.item_gst =='' && this.state.quotationSubmit.item_gst ==0 && formSubmit )return
    // else if(this.state.filename=='' && this.state.filewithbase64 =='')return;

    // else if(this.state.quotationSubmit.item_price =='')return
  //  if(this.state)
  else{
    this.setState({
      QuotationTableData: [
        ...this.state.QuotationTableData,
        this.state.quotationSubmit
    ]})
  }
  let data = {
    item_name: '',
        item_brand: '',
        item_capacity: '',
        item_quantity: '',
        item_price: '',
        item_gst: '',
        item_sub_total:'',
        record_deleted:0,
  }
  this.cost = 0;
  this.gst = 0;
  this.qty=0;
  this.setState({quotationSubmit:data})
  this.setState({isSubmit:false})
  // this.setState({filewithbase64:'',filename:''})
  // this.clearFileUpload();
  }
  _doSubmit=()=>{
    const {QuotationTableData, technicianId, vendorComments, technicianNumber, filename, filewithbase64, quatationTotalsum } = this.state
    this.setState({isTechnicianSelected:true})
    if(QuotationTableData.length==0)return;
    if(technicianId=='')return;
    if(!technicianNumber || technicianNumber.length<10 )return;
    let data={
      fedid :this.userID,
      filename:filename,
      filewithbase64:filewithbase64,
      work_request_id:this.props.SelectedData.work_request_id,
      quotation_total:Number(parseFloat(quatationTotalsum.toFixed(2))),
      quotation_details:QuotationTableData,
      technician_id: technicianId,
      technician_number: technicianNumber,
      vendor_comments: vendorComments
    }
    console.log(data,'QuotationTableData',this.userID)
    this.props.CreateQuotation(data)
    this.setState({isTechnicianSelected:false})

    // this.props.navigate("/QuotationVendor")
  }
  quatationTotal = () =>{
    const {QuotationTableData} = this.state
    let sum = 0
    for(let i=0;i<QuotationTableData.length;i++){
        sum = Number(parseFloat(sum +Number(QuotationTableData[i].item_sub_total)).toFixed(2))
    }
    return sum
  }
  componentDidUpdate(prevProps, prevState){
    if(prevState.QuotationTableData != this.state.QuotationTableData){
      const totalSum = this.quatationTotal()
      this.setState({quatationTotalsum:totalSum})

    }
  }
  render() {
    console.log(this.props,'quotationINfo')
    // console.log(this,'this')
    const { item_sub_total } = this.state;
    return (
      <div>
        <div className="wrapper">
          <Header title={this.state.title} />
          <Menu />
          {
            this.props.QuotationInfo.loading && <Spinner/>
          }
          <div className='content-wrapper'>
            {this.props.QuotationInfo.modalOpen ? (
                <MessageBox
                message={this.props.QuotationInfo.message}
          // signout={"false"}
                onClose={()=>{
                    // this.props.navigate(this.props.location.state.fromAddress)
                  //   this.props.navigate({
                  //     pathname:this.props.location.state.fromAddress, 
                  //     state:{selectedStoreId:this.props.location.state.selectedId}
                  // });
                  this.props.CloseAddQuotation();
                  this.props.ClearMessage();
                }}
                
                 />) : (
              <div>
                <section className='content top-space'>
                  <div className="m-panel">
                    <div className="m-panel__body pb-10">
                      <div className="row m-grid">
                        <div className="col-md-4">

                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Item Name*</label>
                              <input type="text" maxLength="100" className="form-control" value={this.state.quotationSubmit.item_name} onChange={(e) => this.handleInput(e, 'item_name')} />
                              {this.state.quotationSubmit.item_name.trim() == '' && this.state.isSubmit?<span className="text-danger">Please Enter Item Name</span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Brand/Make*</label>
                              <input type="text" maxLength="100" className="form-control" value={this.state.quotationSubmit.item_brand } onChange={(e) => this.handleInput(e, 'item_brand')} />
                              {this.state.quotationSubmit.item_brand.trim() == '' && this.state.isSubmit?<span className="text-danger">Please Enter Brand Name</span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>item_capacity *</label>
                              <input type="text" className="form-control" value={this.state.quotationSubmit.item_capacity} onChange={(e) => this.handleInput(e, 'item_capacity')} />
                              {this.state.quotationSubmit.item_capacity == '' && this.state.isSubmit?<span className="text-danger">Please Enter Capacity </span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>item_quantity *</label>
                              <input type="number" className="form-control" value={this.state.quotationSubmit.item_quantity } onChange={(e) => this.handleInput(e, 'item_quantity')} />
                              {this.state.quotationSubmit.item_quantity == '' && this.state.isSubmit?<span className="text-danger">Please Enter Quantity </span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Cost*</label>
                              <input type="number" className="form-control" value={this.state.quotationSubmit.item_price } onChange={(e) => this.handleInput(e, 'item_price')} />
                              {this.state.quotationSubmit.item_price == '' && this.state.isSubmit?<span className="text-danger">Please Enter Cost </span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>GST*</label>
                              <input type="number" className="form-control" value={this.state.quotationSubmit.item_gst } onChange={(e) => this.handleInput(e, 'item_gst')} />
                              {this.state.quotationSubmit.item_gst == '' && this.state.isSubmit?<span className="text-danger">Please Enter GST</span> : null}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Total</label>
                              <input type="text" className="form-control" value={this.state.quotationSubmit.item_sub_total} onChange={(e) => this.handleInput(e, 'item_sub_total')} disabled />
                              {/* {storeName.trim() == '' && isSubmit == true ? <span className="text-danger">Please Enter Store Name</span> : null} */}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <div className="m-page__button top-space">
                            <button type='button' onClick={this._doAddtoQuotationList} className='btn btn-secondary deca-btn-yellow'>Add</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="m-panel mt-10">
                    <div className="m-panel__body p10">
                      <div className="m-table__main">
                        <div className="m-table__responsive medium-width">
                          <Table filterSearch="true"
                            columns={this.state.QuotationTableColumns}
                            dataSource={this.state.QuotationTableData}

                            summary={pageData => {
                              return (
                                <>
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell colSpan={7} className="text-right">Total</Table.Summary.Cell>
                                    <Table.Summary.Cell>
                                      <Text strong="true">{this.state.quatationTotalsum}</Text>
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                </>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{marginTop:"20px"}}>
                    <div className="col-md-4">
                        <div className="form-group">
                          <div className="form-group" style={{position:'relative'}}>
                            <label htmlFor='exampleInput'>Upload File</label>
                            <input type="file" className="form-control upload-file"  onChange={(e) => this.handleFile(e)} accept={".xls, .xlsx, .pdf"}/><i className="fa fa-refresh" aria-hidden="true" style={{position:'absolute',top:'63%',right:'5%',cursor:'pointer'}} onClick={this.clearFileUpload}></i>
                            {/* {this.state.filename == '' && this.state.isSubmit == true ? <span className="text-danger">Please Upload a File</span> : null} */}
                          </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="exampleInput">Assign Technician</label>
                            <Select className="form-control"
                                placeholder="-- Please Select --"
                                onChange={(value)=>this.setState({technicianId:value})}
                            >
                                {
                                    this.props.TechnicianDetails?.TechnicianList?.map((element,index)=>{
                                        return(
                                            <Option key={index} value={element.technician_id}>{element.technician_name}</Option>
                                        )
                                    })
                                }
                            </Select>
                            {this.state.isTechnicianSelected && this.state.technicianId =='' &&<p className='text-danger'>Please select Technician</p>}
                        </div>
                    </div> 
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label className='custom-label'>Mobile Number</label>
                            <input 
                              type="text" 
                              className='form-control'
                              maxLength='10' 
                              value={this.state.technicianNumber}
                              placeholder='Technician Number' 
                              onChange={e => this.setState({technicianNumber:e.target.value.replace(/[^0-9]/g,'')})}
                              />
                            {(this.state.isTechnicianSelected && (!this.state.technicianNumber || this.state.technicianNumber.length<10)) &&<p className='text-danger'>Please select Technician</p>}
                        </div>
                    </div>
                  </div>
                  <div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                      <label className='custom-label'>Vendor Comments</label>
                          <textarea
                            className='form-control'
                            value={this.state.vendorComments}
                            placeholder='Vendor Comments'
                            maxLength={1000}
                            onChange={e => this.setState({vendorComments:e.target.value.replace(/[^\w\s]/gi, "")})}
                            />
                            {(this.state.isTechnicianSelected && (!this.state.vendorComments || this.state.vendorComments.length<10)) &&<p className='text-danger'>Please enter comments</p>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-right">
                      <div className="m-page__button top-space">
                        <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doNavToQuotationVendor}>Back</button>
                        <button type='button' onClick={this._doSubmit} className='btn btn-secondary deca-btn-yellow'>Submit</button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )};
          </div>
          <Footer />
        </div>
      </div>
    )
  }

}
function mapStateToProps(state) {
  const { QuotationInfo, WorkOrderStore,pmpList } = state
  return { QuotationInfo, SelectedData:WorkOrderStore.SelectedData,TechnicianDetails:pmpList.TechnicianDetails}
}

export default connect(mapStateToProps,{CreateQuotation,ClearMessage,GetTechnicianPMPList}) (AddQuotation);